import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {WarrantyService} from '@ccp/services/warranty/warranty.service';
import {ProductModel} from '@ccp/models/product.model';
import {take, tap} from 'rxjs/operators';
import {map} from 'rxjs/internal/operators/map';
import {Observable, of} from 'rxjs';
import {ProductContextService} from '@ccp/services/app-context/product-context.service';

export const ProductResolver: ResolveFn<Observable<boolean>> = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  productContextService: ProductContextService = inject(ProductContextService),
  warrantyService: WarrantyService = inject(WarrantyService),
): Observable<boolean> => {
  const hash = route.queryParamMap.get('hash');

  if (!productContextService.isProductBeingRegistered$() && hash) {
    const productToExtend = new ProductModel('');
    productToExtend.hash = hash;

    return warrantyService.getProductAndWarranties(productToExtend).pipe(
      take(1),
      tap((response) => {
        if (response !== null && response.length === 1) {
          productContextService.setProductRegistering(response[0]);
        }
      }),
      map(() => true),
    );
  }
  return of(true);
};
